'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (street, street1, zip, city) {
  var state = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var countryCode = arguments[5];

  if (countryCode === 'CN') {
    return [street, street1, state, zip, city].filter(function (part) {
      return part;
    }).join(' ');
  } else {
    return [city, street, street1].filter(function (part) {
      return part;
    }).join(' ');
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/shared/formatAddress.js
// module id = 505
// module chunks = 0